import { render, staticRenderFns } from "./WfViolationsList.vue?vue&type=template&id=8cfb4ac2&scoped=true&"
import script from "./WfViolationsList.vue?vue&type=script&lang=js&"
export * from "./WfViolationsList.vue?vue&type=script&lang=js&"
import style0 from "./WfViolationsList.vue?vue&type=style&index=0&id=8cfb4ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfb4ac2",
  null
  
)

export default component.exports